import React from "react";
import { Link } from "react-router-dom";
import { Clock, MapPin, Users } from "lucide-react";
import FavHeart from "./FavHeart";
import ShareButton from "./ShareButton";
import { formatDate } from "../lib/format";

// Convert ISO 8601 duration (PT4H12M) → "4h 12m"
function fmtDuration(iso) {
  if (!iso || typeof iso !== "string") return "—";
  const m = iso.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
  if (!m) return iso;
  const h = m[1] ? `${m[1]}h ` : "";
  const min = m[2] ? `${m[2]}m` : "";
  return (h + min).trim() || iso;
}

export default function SpacewalkCard({ walk }) {
  const { id, name, start, end, duration, location, crew } = walk;
  return (
    <Link to={`/roster/spacewalk/${id}`} data-testid={`spacewalk-card-${id}`}
      className="sat-surface sat-brackets group block p-5 relative hover:sat-box-glow transition-all">
      <div className="flex items-start justify-between mb-2">
        <div>
          <div className="sat-label sat-cyan">EVA · {formatDate(start)}</div>
          <h3 className="font-display font-bold text-lg mt-1 group-hover:text-[color:var(--sat-cyan)] transition-colors">
            {name}
          </h3>
        </div>
        <div className="flex items-center gap-1.5">
          <ShareButton url={`${window.location.origin}/roster/spacewalk/${id}`} title={name} size={11} testid={`spacewalk-share-${id}`} />
          <FavHeart kind="spacewalk" ref_id={id} title={name} size={12} />
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-3">
        <div>
          <div className="sat-label mb-1"><Clock size={10} className="inline mr-1" /> DURATION</div>
          <div className="font-mono text-sm sat-cyan">{fmtDuration(duration)}</div>
        </div>
        {location && (
          <div>
            <div className="sat-label mb-1"><MapPin size={10} className="inline mr-1" /> STATION</div>
            <div className="font-mono text-sm">{location}</div>
          </div>
        )}
        <div>
          <div className="sat-label mb-1"><Users size={10} className="inline mr-1" /> CREW</div>
          <div className="font-mono text-sm">{(crew || []).length}</div>
        </div>
      </div>
    </Link>
  );
}
